import { CalculatorType, Scenario } from 'spw-redux/modules/calculators/types';
import _ from 'lodash';
import { GROWTH_CALCULATORS } from 'spw-constants';
import { IDepartment } from 'spw-redux/modules/projects/types';
import HeadcountScenario from './HeadcountScenario';
import ProgramScenario, { PlainProgramScenario } from './Scenario';
import ProgramScenarioFactory from './ProgramScenarioFactory';

export default class DepartmentScenario extends HeadcountScenario {
  constructor(apiScenario: Scenario) {
    super(apiScenario);

    const { targetYear, startYear, department } = apiScenario;
    this.primaryLabel = department?.name;

    const targetYearString =
      targetYear === startYear
        ? `Current (${targetYear})`
        : `Year ${targetYear - startYear} (${targetYear})`;
    this.compoundLabel = targetYearString;
    this.calculationsTitlePrefix = 'Department';

    if (department?.secondaryIdentifier) {
      this.secondaryLabel = department.secondaryIdentifier;
      this.compoundLabel = `${department.secondaryIdentifier} | ${targetYearString}`;
    }
  }

  static parseFromAnotherCalculatorType(
    scenario: PlainProgramScenario,
    department: IDepartment,
    departmentsYear?: number
  ) {
    const newScenario = HeadcountScenario.parseToHeadcountScenario(scenario);
    if (
      newScenario.startYear !== departmentsYear &&
      departmentsYear &&
      newScenario.targetYear &&
      newScenario.startYear
    ) {
      newScenario.targetYear =
        departmentsYear + newScenario.targetYear - newScenario.startYear;
      newScenario.startYear = departmentsYear;
      newScenario.endYear =
        newScenario.startYear + scenario.endYear - scenario.startYear;
    }
    newScenario.department = department;
    newScenario.departmentId = department?.id;
    newScenario.calculatorType = GROWTH_CALCULATORS.buildingHeadcountSeatcountDepartments as CalculatorType;

    return ProgramScenarioFactory.create(
      ProgramScenario.toAPIScenario(newScenario)
    );
  }
}
